export default __webpack_public_path__ + "static/media/grey4-top2.30cc1389.svg";